module.exports = __webpack_public_path__ + "ad.no1.82206ae3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ad.no1.jpg
// module id = 0ftW
// module chunks = 0